import RootStore from "./RootStore";
import { IGalleryStatus, IResult } from "../global";
import galleryApi, { IMediaListResult } from "../actions/gallery";
import { observable, action } from "mobx";
import imageApi, { IImageListResult } from "../actions/image";
import { IOneGallery, IOneImage } from "../components/GalleryList/Common";
import { ICheckLoadMore } from "../components/Common/ListWrapper";
import { MessageProps } from "./IMStore";

let isLoadPic = false;
let loadPicCount = 0;

export interface ILoadPicParams {
  first?: boolean;
  uselasttime?: boolean;
  notmerge?: boolean;
  orderchange?: boolean;
  tag?: string;
  person?: boolean; // 人脸识别
  page?: number; // 人脸识别时使用
  hot?: boolean; // 是否是热门图片
}

export type IBrotherPhotoList = {
  name: string;
  link: string;
  status: IGalleryStatus;
}[];
export interface IJigsaw {
  bottomShow: boolean;
  jigsawList: IOneGallery[];
  type: string; //当前是那种类型的拼图，目前支持长图 long和海报 poster，
  from?: string;
}

export default class GalleryStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.rootStore.imStore!.addMessageListener("image_add", this.onMessage);
    this.rootStore.imStore!.addMessageListener("image_delete", this.onMessage);
    this.rootStore.imStore!.addMessageListener("image_show", this.onMessage);
    this.rootStore.imStore!.addMessageListener("image_hide", this.onMessage);
    this.rootStore.imStore!.addMessageListener("image_check", this.onMessage);
    this.rootStore.imStore!.addMessageListener("image_uncheck", this.onMessage);
  }

  @observable hotList = [] as IOneGallery[]; // 热门列表

  @observable jigsaw = {
    bottomShow: false, // 是否显示 拼图的底部，注意，当这个东西出现的时候，包括挂件等都不显示
    jigsawList: [], // 选中的图片列表ID合集
    type: "", //
  } as IJigsaw;

  @observable hot = false;
  @observable personList = [];
  @observable list = [] as IOneGallery[]; // 这是整个照片列表哦
  @observable mediaList = {} as IMediaListResult; // 视频
  @observable total = -1; // 照片列表的总数
  @observable brotherPhotoList = [] as IBrotherPhotoList[];
  @observable watermarks = {} as any;
  @observable payGoods = {} as any;
  @observable disableWatermark = false;

  morePhotoCount = 0;
  @observable morePhoto = 0;

  @action clearMorePhoto = () => {
    this.morePhoto = 0;
    this.morePhotoCount = 0;
    window.clearTimeout(this.__randomTimer);
  };

  @action setDisableWatermark = (val: boolean) => {
    this.disableWatermark = val;
  };

  __randomTimer = 0;
  randomSetMorePhoto = () => {
    window.clearTimeout(this.__randomTimer);

    this.__randomTimer = window.setTimeout(
      action(() => {
        this.morePhoto = this.morePhotoCount;
      }),
      Math.random() * 2000 + 1000
    );
  };

  hideList = [] as string[];
  uncheckList = [] as string[];

  @action filterPhotoList = () => {
    this.list = this.list.filter((it: IOneGallery) => {
      let { id } = it;
      if (this.hideList.indexOf(String(id)) > -1) {
        return false;
      }
      if (this.uncheckList.indexOf(String(id)) > -1) {
        return false;
      }
      return true;
    });
  };

  @action onMessage = (data: MessageProps) => {
    if (data) {
      let { type, gallery_id, current_gallery, image_id } = data;

      let rightGalleryId = window.dataDetail
        ? window.dataDetail.id
        : window.gallery.id;

      if (rightGalleryId == current_gallery) {
        if (type == "image_add") {
          // 这里是需要发全局新增事件的

          let currentTime = 0;
          if (typeof image_id == "string") {
            currentTime = 1;
          }
          if (image_id instanceof Array) {
            currentTime = image_id.length;
          }

          this.morePhotoCount += Number(currentTime);
          this.randomSetMorePhoto();
        }
        if (type == "image_delete") {
          // 这里是需要直接删掉照片的
          this.list = this.list.filter((it: IOneGallery) => {
            if (typeof image_id == "string") {
              return Number(it.id) != Number(image_id);
            } else if (image_id instanceof Array) {
              return image_id.indexOf(Number(it.id)) < 0;
            }
          });
        }

        if (type == "image_hide") {
          if (image_id instanceof Array) {
            image_id.forEach((it) => {
              if (this.hideList.indexOf(String(it)) < 0) {
                this.hideList.push(String(it));
              }
            });
          } else {
            if (this.hideList.indexOf(image_id) < 0) {
              this.hideList.push(image_id);
            }
          }
          this.filterPhotoList();
        }

        if (type == "image_show") {
          this.hideList = this.hideList.filter((it: string) => {
            if (typeof image_id == "string") {
              return Number(it) != Number(image_id);
            } else if (image_id instanceof Array) {
              return image_id.indexOf(String(it)) < 0;
            }
          });
          console.log(this.hideList);
          this.filterPhotoList();
        }

        if (type == "image_check") {
          this.uncheckList = this.uncheckList.filter((it: string) => {
            if (typeof image_id == "string") {
              return Number(it) != Number(image_id);
            } else if (image_id instanceof Array) {
              return image_id.indexOf(String(it)) < 0;
            }
          });
          this.filterPhotoList();
        }

        if (type == "image_uncheck") {
          if (image_id instanceof Array) {
            image_id.forEach((it) => {
              if (this.uncheckList.indexOf(String(it)) < 0) {
                this.uncheckList.push(String(it));
              }
            });
          } else {
            if (this.uncheckList.indexOf(image_id) < 0) {
              this.uncheckList.push(image_id);
            }
          }
          console.log(this.uncheckList);
          this.filterPhotoList();
        }

        // 需要存一下
        let localStorageCommentMessage = Number(
          window.localStorage.getItem(`image_message_${rightGalleryId}`) || 0
        );
        window.localStorage.setItem(
          `image_message_${rightGalleryId}`,
          localStorageCommentMessage + 1 + ""
        );
      }
    }
  };

  getWatermarksByKey = (key: string, show_mark?: number) => {
    // 如果当前是无水印相册
    if (window.original_photo) {
      return [];
    }
    if (/*typeof show_mark == 'undefined' || */ Number(show_mark) === 0) {
      return [];
    }
    if (window.custom_current_watermark) {
      return window.custom_current_watermark;
    }
    return this.watermarks[key];
  };

  @action setWatermarksByKey = (key: string, watermark: any) => {
    if (typeof watermark == "string" && watermark) {
      try {
        watermark = JSON.parse(watermark);
      } catch (e) {
        return;
      }
    }

    if (watermark && !this.watermarks[key]) {
      this.watermarks[key] = watermark;
    }
  };

  getPayGoodByKey = (key: string) => {
    return Number(this.payGoods[key]);
  };

  @action setPayGoodByKey = (key: string, goodId: any) => {
    if (goodId && !this.payGoods[key]) {
      this.payGoods[key] = goodId;
    }
  };

  @action setJigsawBottom = (flag: boolean) => {
    this.jigsaw = {
      ...this.jigsaw,
      bottomShow: flag,
    };
  };
  // 注意，因为下载逻辑一样，所以新增type=download用于下载
  @action setJigsaw = (params: {
    bottomShow?: boolean;
    jigsawList?: IOneGallery[];
    type?: string;
    extra?: string;
    from?: string;
  }) => {
    this.jigsaw = {
      ...this.jigsaw,
      ...params,
    };
  };

  @action setList = (list: IOneGallery[]) => {
    // 避免在其他地方处理会出现在action外修改值的情况
    const theList = list.map(function (it: any, ind: number) {
      if (it.ind === undefined) {
        it.ind = ind;
      }
      return it;
    });
    // 注意，需要知道当前是hotList还是list
    if (this.hot) {
      this.hotList = theList;
    } else {
      this.list = theList;
    }

    setTimeout(() => {
      window.dispatchEvent(new Event("custom-tab-height-change"));
    }, 0);
  };
  @action setTotal = (total: number) => {
    this.total = total;
  };

  @observable listIsPerson = false; //当前加载的列表是人物列表还是正常的图片列表，只有loadPic中传入person的时候这个值才应该赋值为true
  @action setListIsPerson = (flag: boolean) => {
    this.listIsPerson = flag;
  };
  @observable personPage = 1; // 人脸的页码
  @action setPersonPage = (page: number) => {
    this.personPage = page;
  };

  @action setHot = (hot: boolean) => {
    this.hot = hot;
  };

  @observable mode = "1"; //当前相册使用的方式（1列？2列 etc)，注意，这个值会因为用户切换而变化
  @action setMode = (mode: string) => {
    this.mode = mode;
  };
  @observable tag = ""; //tag
  @action setTag = (tag: string) => {
    this.tag = tag;
  };
  @observable tagRefTop = 0; // tagRef的top值
  @action setTagRefTop = (top: number) => {
    this.tagRefTop = top;
  };
  @observable order = (() => {
    let result =
      (window.configDetail.sort || "").indexOf("-") === 0 ? "desc" : "asc";
    let target = window.dataDetail || window.gallery;
    let { start_time, end_time } = target;

    // 去掉活动结束后，默认正序这个需求 - 2019-11-25
    // if (moment().isAfter(end_time)) {
    //   return 'asc';
    // }
    return result;
  })();

  @action setOrder = (order?: string) => {
    if (order) {
      this.order = order;
    } else {
      this.order = this.order === "desc" ? "asc" : "desc";
    }
  };

  getLinkLatest = (link: string) => {
    return galleryApi.linkLatest(link);
  };
  getPersonList = (galleryid: string, page: number = 1) => {
    return galleryApi.person(galleryid, page).then(
      action((res: any) => {
        this.personList = page === 1 ? res : [...this.personList, ...res];
        // 必须返回data/total，用于加载更多是判断，下同

        setTimeout(() => {
          window.dispatchEvent(new Event("custom-tab-height-change"));
        }, 0);
        // 不知道啥时候改的，后端接口给的pageSize=35，估计是考虑性能问题吧 2025-08-25 zihan
        const total = res.length < 35 ? res.length : Infinity;
        // commented by cg on 2019.9.19 这里不能设置total
        // 因为在关注的人 上也会获取这个接口，如果关注的人这个接口返回的total为0
        // 当再切换回第一个tab时，根据AllForGalleryList的逻辑，total===0了会显示无相片了
        // this.setTotal(total);

        return {
          data: res,
          // 根据涵哥的聊天描述，返回数量<=50表示加载结束了，否则就假定还有数据，等加载为空的情况
          total,
        };
      })
    );
  };
  getHotList = (galleryid: string, page: number) => {
    return galleryApi.imagesHot(galleryid, page).then(
      action((res: any) => {
        const { code, data } = res;
        if (code == 200) {
          let { items, total } = data;
          this.setTotal(total);
          this.hotList = page === 1 ? items : [...this.hotList, ...items];
          return {
            data: items,
            total,
          };
        } else {
          console.warn("hot list获取失败", res);
        }

        setTimeout(() => {
          window.dispatchEvent(new Event("custom-tab-height-change"));
        }, 0);

        return {
          data: [],
          total: 0,
        };
      })
    );
  };
  @action getMediaList = (galleryid: string) => {
    return galleryApi.mediaList(galleryid).then(
      action((res: IMediaListResult) => {
        this.mediaList = res;
        return res;
      })
    );
  };

  @action getLiveDetail = (livevideoid: string) => {
    return galleryApi.getLiveDetail(livevideoid).then(
      action((res: IResult) => {
        return res;
      })
    );
  };

  // 重量级的哦，原有的GalleryListWrapper的loadPic丢过来了
  loadPic = (obj: ILoadPicParams) => {
    // console.log("loadPic params:", obj);
    const {
      first = false, // 组件第一次加载时使用，这个理论上和notmerge一样
      uselasttime, // 加载更多时使用
      notmerge, // 刷新用
      orderchange, // 正序与倒序，应该与notmerge一起使用
      tag,
      person,
      hot,
      page,
    } = obj;

    isLoadPic = true;
    if (first || notmerge) {
      loadPicCount = 0;
      this.clearMorePhoto();
      this.hideList = [];
      this.uncheckList = [];
    }
    if (page) {
      this.setPersonPage(page);
    }
    // 只有强制传入了person是true或者false的时候才对这个值进行重新赋值
    // 主要是考虑到，person=true时加载更多时，传入的参数只有uselasttime,不好处理，所以如果已经是person=true的时候，需要回退到
    // 正常的photo模式，请务必强制传入person=false(点击tag或者全部时需要处理这个)
    if (typeof person === "boolean") {
      this.setListIsPerson(person);
    }
    // hot的处理和person类似
    if (typeof hot === "boolean") {
      this.setHot(hot);
    }

    // 带tag的一定不是person/hot，所以可以直接赋值person/hot=false
    // 这是个优化项，如果有问题，请干掉
    if (tag) {
      this.setListIsPerson(false);
      this.setHot(false);
    }

    // person/hot不能带tag
    // 他们除了接口不一样，理论上剩余部分都是一样的
    if (this.listIsPerson || this.hot) {
      this.setTag("");
      // person list加载更多时，更新page
      if (uselasttime) {
        this.setPersonPage(this.personPage + 1);
        // person list刷新时，更新page=1
      } else if (notmerge) {
        this.setPersonPage(1);
      }
    }

    // 该页面只要传递了tag，就一直保留，刷新等都会继续存在
    // 如果有必要，请手动设置tag为空
    if (tag !== undefined) {
      this.setTag(tag);
    }
    // 某些异常情况可能会导致疯狂加载，所以这里如果出现了直接停止掉
    if (loadPicCount > 3) {
      console.warn(
        "sth error happened here, loadPicCount too high",
        loadPicCount
      );
      return;
    }

    // let {sorttype = "-shoottime"} = jData;
    let sorttype = window.configDetail.sort || "-shoottime";
    sorttype = sorttype.replace(/(\+|-)/, "");

    //如果传入了 uselasttime=true，需要根据sorttype取到最后一条数据的当前值，传入给下面的接口
    let lasttime = null;

    // 新接口需要
    let offset = 0;

    const { list } = this;
    if (true === uselasttime) {
      if (list && list.length) {
        // if(this.order == 'desc') {
        const last = list[list.length - 1];
        lasttime = last[sorttype || "shoottime"];
        offset = last.id;
        // }
        // if(this.order == 'asc') {
        //   const first = list[0];
        //   lasttime = first[sorttype || 'shoottime'];
        // }
      }
    }
    //如果更换了order顺序，直接赋值成空，这样list的获取才是OK的
    if (true === orderchange) {
      lasttime = null;
    }
    // order的处理是在挂件里边的！！！
    let order = this.order; // 默认顺序
    if (window.dataDetail && window.dataDetail.id) {
      if (this.hot) {
        return this.getHotList(window.dataDetail.id + "", this.personPage);
      }
      if (this.listIsPerson) {
        return this.getPersonList(window.dataDetail.id + "", this.personPage);
      }
      return imageApi
        .list({
          galleryid: window.dataDetail.id,
          sorttype,
          tag: this.tag,
          order,
          lasttime,
          offset,
        })
        .then(
          action((jsonData: IImageListResult) => {
            let format_list = jsonData.data;
            const { total } = jsonData;
            if (format_list && format_list.length == 0) {
              loadPicCount++;
            }
            //目前包含了data数组，total
            let newList =
              notmerge || first ? format_list : list.concat(format_list);
            this.setList(
              newList
                .map((it: IOneGallery, index: number) => {
                  it.index = index + 1;
                  return it;
                })
                .filter((it: IOneGallery) => {
                  let { id } = it;
                  if (this.hideList.indexOf(String(id)) > -1) {
                    return false;
                  }
                  if (this.uncheckList.indexOf(String(id)) > -1) {
                    return false;
                  }
                  return true;
                })
            );
            this.setTotal(total);

            if (window.dataDetail && window.dataDetail.id) {
              this.rootStore.pagedataStore!.updateGalleryCount(
                String(window.dataDetail!.id),
                total
              );
            }

            return {
              data: newList,
              total,
            };
          })
        );
    } else {
      return new Promise<ICheckLoadMore>((resolve) =>
        resolve({
          data: [],
          total: 0,
        })
      );
    }
  };

  childlist = (link: string) =>
    galleryApi.childlist(link).then(
      action((jsonData: IResult) => {
        this.brotherPhotoList = jsonData.data;
      })
    );

  checkWatermark(galleryid: number) {
    return galleryApi.checkWatermark(galleryid);
  }

  doWatermark(data: any) {
    return galleryApi.doWatermark(data);
  }

  getVideoQrcodeTicket(videoid: number, linkid: string) {
    return galleryApi.getVideoQrcodeTicket(videoid, linkid);
  }

  getNoticeStatus(videoid: number) {
    return galleryApi.getNoticeStatus(videoid);
  }

  getPosterDiyTemplate(ids: string | number[]) {
    return galleryApi.getPosterDiyTemplate(ids.toString());
  }

  uploadImage(gallery_id: string | number, hash: string, keywords?: string, tags?: string) {
    return imageApi.uploadImage(gallery_id, hash, keywords, tags);
  }

  getImageById(ids: string | string[]) {
    return imageApi.getImageById(ids).then((res: any) => {
      if (res && res.watermarks) {
        Object.keys(res.watermarks).map(galleryid => {
          let marks = res.watermarks[Number(galleryid)];
          this.setWatermarksByKey(galleryid, marks);
        });
      }

      return res;
    });
  }
}
